/* eslint-disable */

import React, { useState, useContext, useEffect, useCallback } from "react";
import {
  makeStyles,
  Drawer,
  IconButton,
  Tooltip,
  Tabs,
  Tab,
  Box,
  Typography,
  Button,
  TableBody,
  TableHead,
  Table,
  TableRow,
  TableCell,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
  FormControl,
  TextField,
} from "@material-ui/core";
import PropTypes from "prop-types";
import ReactSelect from "react-select"; // Adicionando ReactSelect para seleção múltipla de iniciativas

// Icons

import AddCircle from "@material-ui/icons/AddCircle";
import Assessment from "@material-ui/icons/Assessment";
import FilterListIcon from "@material-ui/icons/FilterList";
import GridOn from "@material-ui/icons/GridOn";
import Info from "@material-ui/icons/Info";
import Warning from "@material-ui/icons/Warning";
import Tippy from "@tippyjs/react";

import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import AuthContext from "../../contexts/AuthProvider.js";
import { getAltLabel } from "utils/getAltLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilterCircleXmark,
  faSort,
  faSortUp,
  faSortDown,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Line } from "rc-progress";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import "react-perfect-scrollbar/dist/css/styles.css";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Slide as ToastSlide } from "react-toastify";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import {
  cardTitle,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";
import {
  ArrowUpward,
  ArrowForward,
  Cancel,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { client } from "../../services/axiosClient";
import { ThreeDots } from "react-loader-spinner"; // Para loading states
import EmojiObjects from "@material-ui/icons/EmojiObjects";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import PerfectScrollbar from "react-perfect-scrollbar";
import RiskInsightsLoading from "../../components/RiskInsightsLoading/RiskInsightsLoading";
import AIInsightsModal from "../../components/AI/AIInsightsModal";
import CloseIcon from "@material-ui/icons/Close";
import FileCopy from "@material-ui/icons/FileCopy";

// ================== Constantes para Status das Ações ==================
// Estas constantes devem corresponder aos valores do backend
const ACTION_STATUS = {
  ON_HOLD: "On Hold",
  IN_PROGRESS: "In Progress", 
  DONE: "Done",
  ATRASADA: "Atrasada"  // Novo status para ações atrasadas
};

function computeRiskLevel(probability, impact) {
  // Probability: Low, Medium, High
  // Impact: Low, Medium, High
  // Retorna níveis de risco baseados em probabilidade e impacto
  // Usando cores cinzas para evitar confusão com o status do risco

  if (
    (probability === "High" && impact === "High") ||
    (probability === "Medium" && impact === "High") ||
    (probability === "High" && impact === "Medium")
  ) {
    return "High";
  }
  if (
    (probability === "Low" && impact === "High") ||
    (probability === "Medium" && impact === "Medium") ||
    (probability === "High" && impact === "Low")
  ) {
    return "Medium";
  }
  return "Low";
}

// ================== Status Circle Style para Status do Risco (Verde/Amarelo/Vermelho) ==================

const getStatusCircleStyle = (status) => {
  let background, borderColor;
  switch (status) {
    case "Red":
      background = "#FFEBEE";
      borderColor = "#E57373";
      break;
    case "Yellow":
      background = "#FFF9C4";
      borderColor = "#FFB74D";
      break;
    case "Green":
      background = "#C8E6C9";
      borderColor = "#81C784";
      break;
    default:
      background = "#E0E0E0";
      borderColor = "#9E9E9E";
  }
  return {
    background,
    border: `2px solid ${borderColor}`,
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    display: "inline-block",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };
};

// ================== Risk Level Circle Style (Cinza - High/Medium/Low) ==================

const getRiskLevelCircleStyle = (risk_level) => {
  let background, borderColor;
  switch (risk_level) {
    case "High":  // High/High ou High/Medium
      background = "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)";
      borderColor = "#0f0f23";
      break;
    case "Medium":  // Medium/Medium ou Low/High
      background = "linear-gradient(135deg, #4a5568 0%, #5a6c7d 50%, #6b7b8c 100%)";
      borderColor = "#2d3748";
      break;
    case "Low":  // Low/Low ou Low/Medium
      background = "linear-gradient(135deg, #a0aec0 0%, #b8c2cc 50%, #cbd5e0 100%)";
      borderColor = "#718096";
      break;
    default:
      background = "linear-gradient(135deg, #e2e8f0 0%, #edf2f7 50%, #f7fafc 100%)";
      borderColor = "#cbd5e0";
  }
  return {
    background,
    border: `1px solid ${borderColor}`,
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    display: "inline-block",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: `0 1px 3px rgba(0,0,0,0.1)`,
  };
};

// ================== Funções para o novo Summary ==================

// Função para calcular o status geral de um Risk Level
const getRiskLevelGeneralStatus = (riskLevel, risksList) => {
  const risksInLevel = risksList.filter(risk => risk.risk_level === riskLevel);
  if (risksInLevel.length === 0) return "Green";
  
  // Se algum risco está vermelho, o status geral é vermelho
  if (risksInLevel.some(risk => risk.status === "Red")) return "Red";
  // Se algum risco está amarelo, o status geral é amarelo
  if (risksInLevel.some(risk => risk.status === "Yellow")) return "Yellow";
  // Se todos estão verdes, o status geral é verde
  return "Green";
};

// Função para obter a cor do indicador do Risk Level (usando cores da matriz)
const getRiskLevelIndicatorColor = (riskLevel) => {
  switch (riskLevel) {
    case "High":
      return "#0f0f23"; // Mesma cor da matriz High (escuro)
    case "Medium":
      return "#2d3748"; // Mesma cor da matriz Medium (médio)
    case "Low":
      return "#718096"; // Mesma cor da matriz Low (claro)
    default:
      return "#9E9E9E"; // Gray
  }
};

// =================== Component for Risk Summary ==================

const StatusItem = ({ status, count, onClick, progress }) => {
  const barColor = getProgressColor(progress || 0);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        margin: "8px",
      }}
      onClick={() => onClick(status)}
    >
      <div
        style={getStatusCircleStyle(status)}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      />
      <Typography variant="h6" style={{ color: "#555", fontWeight: "bold" }}>
        {count}
      </Typography>

      {/* Average */}
      <div style={{ marginTop: "4px", textAlign: "center" }}>
        <Typography
          variant="caption"
          style={{ color: barColor, fontWeight: "bold" }}
        >
          {progress}%
        </Typography>
        <Line
          percent={progress}
          strokeWidth={5}
          trailWidth={5}
          strokeColor={barColor}
          trailColor="#e0e0e0"
          strokeLinecap="round"
          style={{
            width: "80px",
            marginTop: "4px",
          }}
        />
      </div>
    </div>
  );
};

StatusItem.propTypes = {
  status: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
};

// ==================== function to calculate progress of a specific type (mitigation or contingency) =================

function calculatePlanProgress(risk, planType) {
  // If the plan is not active, it returns 100%
  if (planType === "mitigation" && !risk.hasMitigationPlan) return 100;
  if (planType === "contingency" && !risk.hasContingencyPlan) return 100;

  let totalActions = 0;
  let doneActions = 0;
  
  // Validação de segurança
  if (!risk.rootCauses || !Array.isArray(risk.rootCauses)) return 100;

  risk.rootCauses.forEach((rc) => {
    if (rc.actions && Array.isArray(rc.actions)) {
      // Only the specified type Actions counts
      const filtered = rc.actions.filter((act) => act.type === planType);
      totalActions += filtered.length;
      filtered.forEach((act) => {
        if (act.status === ACTION_STATUS.DONE) doneActions += 1;
      });
    }
  });

  // If there is no active action, it returns 100%
  if (totalActions === 0) return 100;
  return Math.round((doneActions / totalActions) * 100);
}

// Returns the base color (in hex or name) depending on the interval

function getProgressColor(percentage) {
  if (percentage >= 100) {
    return "#4CAF50"; // Green
  } else if (percentage >= 50) {
    return "#FFC107"; // Yellow
  } else {
    return "#F44336"; // Red
  }
}

function calculateOverallProgress(risk) {
  let totalActions = 0;
  let doneActions = 0;
  
  // Validação de segurança
  if (!risk.rootCauses || !Array.isArray(risk.rootCauses)) return 100;

  risk.rootCauses.forEach((rc) => {
    if (rc.actions && Array.isArray(rc.actions)) {
      rc.actions.forEach((act) => {
        // Only counts the active actions:
        // Skip actions that don't have active plans
        if (act.type === "mitigation" && !risk.hasMitigationPlan) return;
        if (act.type === "contingency" && !risk.hasContingencyPlan) return;
        
        totalActions++;
        if (act.status === ACTION_STATUS.DONE) doneActions++;
      });
    }
  });

  // If there is no active action, progress is 100%
  if (totalActions === 0) return 100;
  return Math.round((doneActions / totalActions) * 100);
}

export default function RiskManagement() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#26a69a";
  const { t } = useTranslation();

  // ================= Sytyles ===================

  const RiskManagementStyles = (theme, clientColor, barColor) => ({
    ...customSelectStyle(theme, clientColor),
    ...customInputStyle(clientColor),
    container: {
      marginTop: "10px",
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "0px",
      marginBottom: "0px",
      padding: "10px",
    },
    tableHeadCell: {
      fontWeight: "bold",
      backgroundColor: "white",
      cursor: "pointer",
    },
    sortIcon: {
      fontSize: "14px",
      marginLeft: "6px",
      color: "#ccc",
    },
    activeSortIcon: {
      color: "#aaa",
    },
    summaryCard: {
      height: "auto",
      minHeight: "25vh",
      display: "flex",
      flexDirection: "column",
      marginBottom: "16px",
    },
    // Estilos para o novo Summary baseado no RiskSummary.js
    summaryContent: {
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      flex: 1,
    },
    summarySection: {
      marginBottom: "8px",
    },
    sectionTitle: {
      fontSize: "0.7rem",
      fontWeight: "600",
      marginBottom: "8px",
      color: "#555",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    riskLevelCounters: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "space-between",
      alignItems: "stretch",
      width: "100%",
    },
    riskLevelChip: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "8px 6px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      border: "2px solid transparent",
      minHeight: "60px",
      flex: "1 1 0%",
      position: "relative",
      overflow: "hidden",
      gap: "6px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      },
    },
    riskLevelIndicator: {
      width: "100%",
      height: "4px",
      borderRadius: "2px",
      position: "absolute",
      left: 0,
      top: 0,
    },
    riskLevelCount: {
      fontSize: "1.2rem",
      fontWeight: "700",
      minWidth: "28px",
      textAlign: "center",
    },
    riskLevelInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "2px",
      textAlign: "center",
    },
    riskLevelLabel: {
      fontSize: "0.7rem",
      fontWeight: "600",
      color: "#666",
      textTransform: "uppercase",
      letterSpacing: "0.3px",
      lineHeight: 1,
    },
    riskLevelPercentage: {
      fontSize: "0.6rem",
      color: "#999",
      fontWeight: "500",
      lineHeight: 1,
    },
    riskLevelStatus: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      flexShrink: 0,
    },
    matrixCard: {
        height: "auto",
      minHeight: "35vh",
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        minHeight: "auto",
      },
      marginTop: "0px",
    },
    matrixGrid: {
      display: "grid",
      gridTemplateRows: "repeat(3, 1fr)",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "5px",
      width: "100%",
      maxWidth: "340px",
      aspectRatio: "1",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        aspectRatio: "1",
      },
    },
    matrixCell: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      fontSize: "0.8rem",
      borderRadius: "4px",
      position: "relative",
      overflow: "hidden",
      cursor: "pointer",
      border: "1px solid #ccc",
      "&:hover": {
        backgroundColor: `${clientColor}1A`,
      },
    },
    summaryContent: {
      display: "flex",
      alignItems: "center",
      overflowX: "auto", // Horizontal Enables Scrollbar
    },
    totalRisks: {
      fontSize: "2.0rem",
      fontWeight: 100,
      color: "#FF5722",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    highlightText: {
      color: "#333333",
      marginBottom: theme.spacing(1),
      textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
      fontSize: "1.2rem",
    },
    riskCount: {
      fontSize: "3rem",
      fontWeight: 700,
      color: "#FF5722",
      textAlign: "center",
      transition: "transform 0.3s ease, opacity 0.3s ease",
    },
    statusContainer: {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(2),
    },
    riskTableCard: {
      height: "100%",
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
    },
    drawerPaper: {
      width: "520px",
      maxWidth: "90vw",
      padding: theme.spacing(2),
    },
    cardButton: {
      padding: "0 !important",
      margin: "15px 15px 0 10px !important",
      height: "24px !important",
      width: "32px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      backgroundColor: clientColor + " !important",
      "&.MuiButton-root": {
        cursor: "pointer",
      },
    },
    cardButtonCancel: {
      padding: "0 !important",
      margin: "15px 15px 0 10px !important",
      height: "24px !important",
      width: "32px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      backgroundColor: "#ff9800 !important",
      "&.MuiButton-root": {
        cursor: "pointer",
      },
    },
    cardButtonIcon: {
      margin: "0 !important",
      position: "absolute !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%)",
      width: "18px !important",
      height: "18px !important",
      color: "#FFFFFF",
    },
    filterSection: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      padding: "0 16px",
      position: "relative",
    },
    clearFiltersWrapper: {
      position: "relative",
      display: "inline-block",
      marginRight: theme.spacing(2),
    },
    clearFiltersIcon: {
      position: "absolute",
      bottom: "1px",
      right: "13px",
      backgroundColor: "transparent",
      color: "#666",
      fontSize: "10px",
      fontWeight: "bold",
      borderRadius: "50%",
      width: 10,
      height: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    selectFormControlOverride: {
      margin: "3px 0 5px 0 !important",
      paddingTop: "1px",
      paddingBottom: "1px",
      "& > div": {
        "&:before": {
          borderBottomWidth: "0.8px !important",
        },
      },
    },
    inputText: {
      color: "#666", // Standard text color

      "&:focus": {
        color: "#666", // Text color when selected
      },
    },
    labelText: {
      color: "#666", // Label Standard Color

      "&.Mui-focused": {
        color: "#666", // LABEL COLOR When focused
      },
    },
    textFieldRoot: {
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #ccc",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: `2px solid ${clientColor}`,
      },
      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${clientColor}`,
      },
    },
    tabsRoot: {
      backgroundColor: grayColor[8],
    },
    tabRoot: {
      fontSize: "1rem",
      fontWeight: 400,
      color: "black",
      textTransform: "uppercase",
      "&:hover": {
        color: clientColor,
        opacity: 1,
      },
      "&.Mui-selected": {
        color: "black",
        fontWeight: 500,
        borderBottom: `2px solid ${clientColor}`,
      },
      "&:focus": {
        color: "black",
      },
    },
    indicator: {
      backgroundColor: clientColor,
      height: "1.5px",
    },
    actionContainer: {
      border: "1px solid #ccc",
      borderRadius: "6px",
      padding: "16px", // 8px increased to 16px

      marginBottom: "25px", // Increased to give more spacing between actions
    },
    actionHeader: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "4px",
      alignItems: "center",
    },
    updateContainer: {
      marginTop: "8px",
      paddingLeft: "10px",
      borderLeft: `3px dashed ${clientColor}`,
      marginBottom: "8px", // Added to space the content below
    },
    updateEntry: {
      fontSize: "0.8rem",
      marginBottom: "6px",
    },
    newActionForm: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      border: "1px solid #ccc",
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#fafafa",
    },
    rootCauseContainer: {
      border: `0.5px dashed ${clientColor}`,
      borderRadius: "6px",
      padding: "16px",
      marginBottom: "16px",
    },
    rootCauseHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
    },
    myCustomProgress: {
      height: "6px",
      marginTop: "4px",
      borderRadius: "10px",
      backgroundColor: "#e0e0e0",
      "& .MuiLinearProgress-bar": {
        // bar color

        backgroundColor: barColor,
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    iconButtonCustom: {
      cursor: "pointer",
      "&:hover": {
        color: clientColor,
      },
    },
    actionIconsCustom: {
      display: "flex",
      gap: theme.spacing(1),
      justifyContent: "center",
      alignItems: "center",
    },
  });

  const useStyles = makeStyles((theme) => ({
    ...RiskManagementStyles(theme, clientColor),
  }));
  const classes = useStyles();

  // ================== Main Risk State ==================

  const [risks, setRisks] = useState([]);

  const [userOptions, setUserOptions] = useState([]);
  const [initiativeOptions, setInitiativeOptions] = useState([]); // Novo estado para opções de iniciativas
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const BLANK_RISK_FORM = {
    title: "",
    probability: "Medium",
    impact: "Medium",
    owner: "",
    description: "",
    dueDate: "",
    hasMitigationPlan: false,
    hasContingencyPlan: false,
    rootCauses: [], // up to three items
    status: "Green", // Novo campo para status
    isMaterialized: false, // Novo campo para risco materializado
    linkedInitiatives: [], // Novo campo para iniciativas vinculadas
  };

  // ================== Fetch Data ==================

  const fetchRiskData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await client.post("/api/risk-management/", {
        action: "list_risks",
      });
      
      if (response.data && response.data.success) {
        // The backend already calculates risk_level, so no need to recalculate here
        const risks = response.data.risks || [];
        const users = response.data.user_options || [];
        const initiatives = response.data.initiative_options || [];
        
        // Validate data structure
        if (!Array.isArray(risks)) {
          console.error("Invalid risks data structure received from backend");
          setError("Estrutura de dados inválida recebida do backend");
          setRisks([]);
          return;
        }
        
        if (!Array.isArray(users)) {
          console.error("Invalid user options data structure received from backend");
          setError("Estrutura de dados de usuários inválida recebida do backend");
          setUserOptions([]);
          return;
        }
        
        if (!Array.isArray(initiatives)) {
          console.error("Invalid initiative options data structure received from backend");
          setError("Estrutura de dados de iniciativas inválida recebida do backend");
          setInitiativeOptions([]);
          return;
        }
        
        setRisks(risks);
        setUserOptions(users);
        setInitiativeOptions(initiatives);
        setError(null);
      } else {
        const errorMsg = response.data.error || "Falha ao carregar riscos.";
        setError(errorMsg);
        setRisks([]); // Clear risks on error
        console.error("Backend error:", errorMsg);
      }
    } catch (err) {
      console.error("Error fetching risks:", err);
      const errorMsg = err.message || "Ocorreu um erro ao buscar riscos.";
      setError(errorMsg);
      setRisks([]); // Clear risks on critical error
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array means this function is created once

  useEffect(() => {
    fetchRiskData();
  }, [fetchRiskData]); // fetchRiskData is now a dependency

  // ================== filter ===================

  const [filters, setFilters] = useState({
    status: "", // Novo filtro para status
    risk_level: "",
    probability: "",
    impact: "",
  });
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const filteredRisks = risks.filter((r) => {
    const statusOk = !filters.status || r.status === filters.status;
    const levelOk = !filters.risk_level || r.risk_level === filters.risk_level;
    const probOk =
      !filters.probability || r.probability === filters.probability;
    const impOk = !filters.impact || r.impact === filters.impact;
    return statusOk && levelOk && probOk && impOk;
  });

  // ================== Order ===================

  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  function handleSort(key) {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  }
  function sortData(data, config) {
    if (!config.key) return data;
    const { key, direction } = config;
    return [...data].sort((a, b) => {
      const aVal = (a[key] || "").toString().toLowerCase();
      const bVal = (b[key] || "").toString().toLowerCase();
      if (aVal < bVal) return direction === "ascending" ? -1 : 1;
      if (aVal > bVal) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  }
  const finalList = sortData(filteredRisks, sortConfig);

  // ================== Contagens para Summary (Status: Red, Yellow, Green) ==================

  const redCount = risks.filter((r) => r.status === "Red").length;
  const yellowCount = risks.filter((r) => r.status === "Yellow").length;
  const greenCount = risks.filter((r) => r.status === "Green").length;
  const totalCount = risks.length;

  function averageProgressForStatus(risks, status) {
    const filtered = risks.filter((r) => r.status === status);
    if (filtered.length === 0) return 0;

    let total = 0;
    filtered.forEach((rk) => {
      total += calculateOverallProgress(rk);
    });
    // Average

    return Math.round(total / filtered.length);
  }

  // in its component

  const redAvgProgress = averageProgressForStatus(risks, "Red");
  const yellowAvgProgress = averageProgressForStatus(risks, "Yellow");
  const greenAvgProgress = averageProgressForStatus(risks, "Green");

  // ================== Risk Matrix 3x3 ===================

  const matrixCells = [
    // Line 1: Probability = High

    { prob: "High", imp: "Low" },
    { prob: "High", imp: "Medium" },
    { prob: "High", imp: "High" },
    // Line 2: Probability = Medium

    { prob: "Medium", imp: "Low" },
    { prob: "Medium", imp: "Medium" },
    { prob: "Medium", imp: "High" },
    // Linha 3: Probability = Low

    { prob: "Low", imp: "Low" },
    { prob: "Low", imp: "Medium" },
    { prob: "Low", imp: "High" },
  ];
  function getCellCount(prob, imp) {
    return risks.filter((r) => r.probability === prob && r.impact === imp)
      .length;
  }
  function handleMatrixCellClick(prob, imp) {
    setFilters((prev) => ({
      ...prev,
      probability: prob,
      impact: imp,
    }));
  }

  // =================== Background Color for the cell as Risk_Level ==================

  function getRiskLevelStyle(risk_level) {
    let background, borderColor, textColor;
    switch (risk_level) {
      case "High":
        background = "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)";
        borderColor = "#0f0f23";
        textColor = "#ffffff";
        break;
      case "Medium":
        background = "linear-gradient(135deg, #4a5568 0%, #5a6c7d 50%, #6b7b8c 100%)";
        borderColor = "#2d3748";
        textColor = "#ffffff";
        break;
      case "Low":
        background = "linear-gradient(135deg, #a0aec0 0%, #b8c2cc 50%, #cbd5e0 100%)";
        borderColor = "#718096";
        textColor = "#2d3748";
        break;
      default:
        background = "linear-gradient(135deg, #e2e8f0 0%, #edf2f7 50%, #f7fafc 100%)";
        borderColor = "#cbd5e0";
        textColor = "#4a5568";
    }
    return {
      background,
      border: `1px solid ${borderColor}`,
      borderRadius: "6px",
      color: textColor,
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: `0 2px 4px rgba(0,0,0,0.1)`,
      fontWeight: "500",
    };
  }

  // =================== Drawer of risk details ===================

  const [selectedRisk, setSelectedRisk] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [detailTab, setDetailTab] = useState(0);

  function openRiskDrawer(risk) {
    setSelectedRisk(risk);
    setIsDrawerOpen(true);
    setDetailTab(0);
  }
  function handleTabChange(event, newValue) {
    setDetailTab(newValue);
  }

  function closeRiskDrawer() {
    setIsDrawerOpen(false);
    setIsNewRiskDrawerOpen(false);
    setSelectedRisk(null);
    setDetailTab(0);
    setHasUnsavedChanges(false);
    
    // Reset action-related states
    setNewActionRootCauseId(null);
    setNewActionType(null);
    setNewActionData({
      title: "",
      status: ACTION_STATUS.ON_HOLD,
      owner: "",
      dueDate: "",
    });
    
    // Reset update form states
    setActionOpenUpdateForm(null);
    setNewUpdateComment("");
    setNewUpdateStatus("");
  }

  // ================== Form for creation of new risk ==================

  const [isNewRiskDrawerOpen, setIsNewRiskDrawerOpen] = useState(false);
  const [newRiskForm, setNewRiskForm] = useState({
    title: "",
    probability: "Medium",
    impact: "Medium",
    owner: "",
    description: "",
    dueDate: "",
    hasMitigationPlan: false,
    hasContingencyPlan: false,
    rootCauses: [], // up to 3
    status: "Green",
    isMaterialized: false,
    linkedInitiatives: [],
  });

  // Load `selectedRisk` and `newRiskForm` from localStorage to avoid losing data if the drawer is closed

  React.useEffect(() => {
    const storedString = localStorage.getItem("draftRiskManagement");
    if (storedString) {
      const { selectedRisk, newRiskForm, savedAt } = JSON.parse(storedString);
      // Check if more than 24h have passed

      if (Date.now() - savedAt > 24 * 60 * 60 * 1000) {
        localStorage.removeItem("draftRiskManagement");
      } else {
        // RESTORE THE DATA

        if (selectedRisk) {
          setSelectedRisk(selectedRisk);
        }
        if (newRiskForm) {
          setNewRiskForm(newRiskForm);
        }
      }
    }
  }, []);

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Save any changes to `selectedRisk` or `newRiskForm` in localStorage

  React.useEffect(() => {
    const dataToStore = {
      selectedRisk,
      newRiskForm,
      savedAt: Date.now(),
    };
    localStorage.setItem("draftRiskManagement", JSON.stringify(dataToStore));
  }, [selectedRisk, newRiskForm]);

  async function saveNewRisk() {
    // Enhanced validation
    if (!newRiskForm.title || !newRiskForm.owner) {
      toast.error(t("riskmanagement.validation.fillRequiredFields"));
      return;
    }

    // Validate root causes have actions if plans are enabled
    if (newRiskForm.hasMitigationPlan || newRiskForm.hasContingencyPlan) {
      if (!newRiskForm.rootCauses || newRiskForm.rootCauses.length === 0) {
        toast.error(t("riskmanagement.validation.rootCauseRequired"));
        return;
      }
      
      // Validate that each root cause has at least one action
      const hasActions = newRiskForm.rootCauses.some(rc => 
        rc.actions && Array.isArray(rc.actions) && rc.actions.length > 0
      );
      
      if (!hasActions) {
        toast.error(t("riskmanagement.validation.actionRequired"));
        return;
      }
    }

    setLoading(true);
    try {
      const response = await client.post("/api/risk-management/", {
        action: "create_risk",
        risk_payload: newRiskForm,
      });
      
      if (response.data && response.data.success) {
        // Add the new risk (returned from backend with ID and calculated fields) to the list
        setRisks((prevRisks) => [...prevRisks, response.data.risk]);
        setIsNewRiskDrawerOpen(false);
        setNewRiskForm({ ...BLANK_RISK_FORM });
        setHasUnsavedChanges(false);
        localStorage.removeItem("draftRiskManagement"); // Clear draft
        
        // Show success message
        toast.success(t("riskmanagement.messages.riskCreatedSuccess"));
      } else {
        toast.error(t("riskmanagement.errors.failedToSave") + (response.data.error || ""));
      }
    } catch (err) {
      console.error("Error saving new risk:", err);
      toast.error(t("riskmanagement.errors.unexpectedError") + ": " + err.message);
    } finally {
      setLoading(false);
    }
  }

  // ================= Update risk (save) ==================

  async function updateRisk(updatedRiskData) {
    if (!updatedRiskData || !updatedRiskData.id) {
      toast.error(t("riskmanagement.errors.cannotUpdateNoId"));
      return;
    }

    // Enhanced validation
    if (!updatedRiskData.title || !updatedRiskData.owner) {
      toast.error(t("riskmanagement.validation.fillRequiredFields"));
      return;
    }

    // Validate root causes have actions if plans are enabled
    if (updatedRiskData.hasMitigationPlan || updatedRiskData.hasContingencyPlan) {
      if (!updatedRiskData.rootCauses || updatedRiskData.rootCauses.length === 0) {
        toast.error(t("riskmanagement.validation.rootCauseRequired"));
        return;
      }
      
      // Validate that each root cause has at least one action
      const hasActions = updatedRiskData.rootCauses.some(rc => 
        rc.actions && Array.isArray(rc.actions) && rc.actions.length > 0
      );
      
      if (!hasActions) {
        toast.error(t("riskmanagement.validation.actionRequired"));
        return;
      }
    }

    setLoading(true);
    try {
      const response = await client.post("/api/risk-management/", {
        action: "update_risk",
        risk_payload: updatedRiskData,
      });
      
      if (response.data && response.data.success) {
        // Update the risk in the list
        setRisks((prevRisks) =>
          prevRisks.map((r) =>
            r.id === response.data.risk.id ? response.data.risk : r
          )
        );
        closeRiskDrawer(); // This already sets selectedRisk to null and hasUnsavedChanges to false
        localStorage.removeItem("draftRiskManagement"); // Clear draft
        
        // Show success message
        toast.success(t("riskmanagement.messages.riskUpdatedSuccess"));
      } else {
        toast.error(t("riskmanagement.errors.failedToUpdate") +
            (response.data.error || ""));
      }
    } catch (err) {
      console.error("Error updating risk:", err);
      toast.error(t("riskmanagement.errors.unexpectedError") + ": " + err.message);
    } finally {
      setLoading(false);
    }
  }

  // ================== DELETE RISK ==================

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [riskToDelete, setRiskToDelete] = useState(null);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);

  // Estados para AI Insights
  const [insightsModalOpen, setInsightsModalOpen] = useState(false);
  const [insightsLoading, setInsightsLoading] = useState(false);
  const [insightsContent, setInsightsContent] = useState("");
  const [insightsError, setInsightsError] = useState(null);
  const [isCopyingInsights, setIsCopyingInsights] = useState(false);

  // Função para buscar insights de AI
  const handleGetAIInsights = async () => {
    setInsightsModalOpen(true);
    setInsightsLoading(true);
    setInsightsContent("");
    setInsightsError(null);

    try {
      const response = await client.post("/api/ai-assistant/", {
        prompt_type: "risk_gap_analysis",
        context: {}
      });

      if (response.data && response.data.success) {
        setInsightsContent(response.data.content || response.data.text);
      } else {
        setInsightsError(
          response.data.error || t("risk_insights.error_loading")
        );
      }
    } catch (err) {
      console.error("Error fetching AI insights:", err);
      setInsightsError(
        err.response?.data?.error || 
        err.message || 
        t("risk_insights.error_loading")
      );
    } finally {
      setInsightsLoading(false);
    }
  };

  // Função para fechar o modal de insights
  const handleCloseInsights = () => {
    setInsightsModalOpen(false);
    setInsightsContent("");
    setInsightsError(null);
  };

  // Função para copiar insights para o clipboard
  const handleCopyInsightsToClipboard = async () => {
    if (!insightsContent) return;
    
    setIsCopyingInsights(true);
    try {
      await navigator.clipboard.writeText(insightsContent);
      toast.success(t("risk_insights.copied_success"), {
        position: "top-right",
        autoClose: 2000,
        transition: ToastSlide,
      });
    } catch (err) {
      console.error("Failed to copy insights to clipboard:", err);
      toast.error(t("risk_insights.error_loading"), {
        position: "top-right",
        autoClose: 2000,
        transition: ToastSlide,
      });
    } finally {
      setTimeout(() => setIsCopyingInsights(false), 300);
    }
  };

  function handleOpenDeleteDialog(risk) {
    // Stores the risk we want to delete

    setRiskToDelete(risk);
    setDeleteDialogOpen(true);
  }

  function handleCloseDeleteDialog() {
    setDeleteDialogOpen(false);
    setRiskToDelete(null);
  }

  async function handleDeleteRisk() {
    if (!riskToDelete || !riskToDelete.id) {
      console.error("No risk selected for deletion");
      return;
    }

    setLoading(true);
    try {
      const response = await client.post("/api/risk-management/", {
        action: "delete_risk",
        risk_id: riskToDelete.id,
      });
      
      if (response.data && response.data.success) {
        setRisks((prevRisks) =>
          prevRisks.filter((r) => r.id !== riskToDelete.id)
        );
        handleCloseDeleteDialog(); // This also sets riskToDelete to null
        
        // Show success message
        toast.success(t("riskmanagement.messages.riskDeletedSuccess"));
      } else {
        toast.error(t("riskmanagement.errors.failedToDelete") +
            (response.data.error || ""));
      }
    } catch (err) {
      console.error("Error deleting risk:", err);
      toast.error(t("riskmanagement.errors.unexpectedError") + ": " + err.message);
    } finally {
      setLoading(false);
    }
  }

  // ================== actions within each rootcause ==================
  // Each Action -> {id, type, title, status, owner, duedat, updates []}

  function addActionToRootCause(risk, rcId, newAction) {
    // Validação de segurança
    if (!risk || !rcId || !newAction) {
      console.error("Invalid parameters for addActionToRootCause");
      return;
    }

    if (!risk.rootCauses || !Array.isArray(risk.rootCauses)) {
      console.error("Risk rootCauses is not an array");
      return;
    }

    const updatedRootCauses = risk.rootCauses.map((rc) =>
      rc.id === rcId 
        ? { 
            ...rc, 
            actions: Array.isArray(rc.actions) ? [...rc.actions, newAction] : [newAction] 
          } 
        : rc
    );

    if (isNewRiskDrawerOpen) {
      // ⬅️  we are creating a NEW risk
      setNewRiskForm((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    } else {
      // ⬅️  we are editing an EXISTING risk
      setSelectedRisk((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    }
    
    setHasUnsavedChanges(true);
  }

  function removeAction(risk, rcId, actionId) {
    // Validação de segurança
    if (!risk || !rcId || !actionId) {
      console.error("Invalid parameters for removeAction");
      return;
    }

    if (!risk.rootCauses || !Array.isArray(risk.rootCauses)) {
      console.error("Risk rootCauses is not an array");
      return;
    }

    const updatedRootCauses = risk.rootCauses.map((rc) =>
      rc.id === rcId
        ? { 
            ...rc, 
            actions: rc.actions && Array.isArray(rc.actions) 
              ? rc.actions.filter((a) => a.id !== actionId) 
              : [] 
          }
        : rc
    );

    if (isNewRiskDrawerOpen) {
      setNewRiskForm((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    } else {
      setSelectedRisk((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    }
    
    setHasUnsavedChanges(true);
  }

  // ================= Update fields of action ==================

  function updateActionField(riskData, rcId, actionId, field, value) {
    // Validação de segurança
    if (!riskData || !riskData.rootCauses || !Array.isArray(riskData.rootCauses)) {
      console.error("Invalid risk data for action update");
      return;
    }

    const updatedRootCauses = riskData.rootCauses.map((rc) =>
      rc.id === rcId
        ? {
            ...rc,
            actions: rc.actions && Array.isArray(rc.actions) 
              ? rc.actions.map((a) =>
              a.id === actionId ? { ...a, [field]: value } : a
                )
              : []
          }
        : rc
    );

    if (isNewRiskDrawerOpen) {
      setNewRiskForm((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    } else {
      setSelectedRisk((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    }
    setHasUnsavedChanges(true);
  }

  // ================= Add Update/Comment to Action ==================

  const [actionOpenUpdateForm, setActionOpenUpdateForm] = useState(null);
  const [newUpdateComment, setNewUpdateComment] = useState("");
  const [newUpdateStatus, setNewUpdateStatus] = useState("");
  function openUpdateForm(actionId) {
    setActionOpenUpdateForm(actionId);
    setNewUpdateComment("");
    setNewUpdateStatus("");
  }
  function closeUpdateForm() {
    setActionOpenUpdateForm(null);
    setNewUpdateComment("");
    setNewUpdateStatus("");
  }

  function addUpdateToAction(risk, rcId, action) {
    if (!newUpdateComment.trim()) return;

    const oldStatus = action.status;
    // Se um novo status foi selecionado, use-o; caso contrário, mantenha o atual
    const finalStatus = newUpdateStatus && newUpdateStatus.trim() !== "" ? newUpdateStatus : oldStatus;

    // Determina o nome do usuário de forma robusta
    let userName = "Unknown User";
    if (userDetails?.user?.get_full_name) {
      userName = userDetails.user.get_full_name;
    } else if (userDetails?.user?.name) {
      userName = userDetails.user.name;
    } else if (userDetails?.user?.username) {
      userName = userDetails.user.username;
    } else if (userDetails?.user?.first_name && userDetails?.user?.last_name) {
      userName = `${userDetails.user.first_name} ${userDetails.user.last_name}`.trim();
    } else if (userDetails?.user?.first_name) {
      userName = userDetails.user.first_name;
    } else if (userDetails?.user?.email) {
      userName = userDetails.user.email;
    }
    
    console.log("DEBUG - userDetails para ActionUpdate:", userDetails);
    console.log("DEBUG - userName escolhido:", userName);

    const newUpd = {
      date: new Date().toISOString().substr(0, 10),
      user: userName,
      oldStatus,
      newStatus: finalStatus,
      comment: newUpdateComment,
    };

    // Validação de segurança
    if (!risk || !risk.rootCauses || !Array.isArray(risk.rootCauses)) {
      console.error("Invalid risk data for update");
      return;
    }

    const updatedRootCauses = risk.rootCauses.map((rc) =>
      rc.id === rcId
        ? {
            ...rc,
            actions: rc.actions && Array.isArray(rc.actions)
              ? rc.actions.map((a) =>
              a.id === action.id
                ? {
                    ...a,
                    status: finalStatus,
                        updates: Array.isArray(a.updates) ? [...a.updates, newUpd] : [newUpd],
                  }
                : a
                )
              : []
          }
        : rc
    );

    if (isNewRiskDrawerOpen) {
      setNewRiskForm((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    } else {
      setSelectedRisk((prev) => ({ ...prev, rootCauses: updatedRootCauses }));
    }

    closeUpdateForm();
  }

  // ================= Add New Action ===================

  const [newActionRootCauseId, setNewActionRootCauseId] = useState(null);
  const [newActionType, setNewActionType] = useState(null);
  const [newActionData, setNewActionData] = useState({
    title: "",
    status: ACTION_STATUS.ON_HOLD,
    owner: "",
    dueDate: "",
  });

  // Open the New Action form

  function openNewActionForm(rcId, type) {
    if (!rcId || !type) {
      console.error("Invalid parameters for openNewActionForm");
      return;
    }
    
    setNewActionRootCauseId(rcId);
    setNewActionType(type);
    // Reset Campos

    setNewActionData({
      title: "",
      status: ACTION_STATUS.ON_HOLD,
      owner: "",
      dueDate: "",
    });
  }

  // Close New Action Form

  function closeNewActionForm() {
    setNewActionRootCauseId(null);
    setNewActionType(null);
    setNewActionData({
      title: "",
      status: ACTION_STATUS.ON_HOLD,
      owner: "",
      dueDate: "",
    });
  }

  // Save the new action and clean the form

  function saveNewAction(risk, rcId) {
    if (!newActionData.title.trim()) {
      // If you don't have a title, don't create
      return;
    }

    // Validação de segurança
    if (!risk || !rcId) {
      console.error("Invalid risk or root cause ID for new action");
      return;
    }

    if (!newActionType || !["mitigation", "contingency"].includes(newActionType)) {
      console.error("Invalid action type");
      toast.error(t("riskmanagement.errors.invalidActionType"));
      return;
    }

    const newAction = {
      id: "AC" + Date.now() + "_" + Math.random().toString(36).substr(2, 5),
      type: newActionType, // "mitigation" ou "contingency"
      title: newActionData.title,
      status: newActionData.status,
      owner: newActionData.owner,
      dueDate: newActionData.dueDate,
      updates: [],
    };

    // Reuses the function of inserting into the array
    addActionToRootCause(risk, rcId, newAction);
    closeNewActionForm();
  }

  const handleOpenNewRiskDrawer = () => {
    setSelectedRisk(null); // make 100 % sure we are **not** in edit mode
    setNewRiskForm({ ...BLANK_RISK_FORM });
    localStorage.removeItem("draftRiskManagement"); // drop any abandoned draft
    setHasUnsavedChanges(false);
    setIsNewRiskDrawerOpen(true);
    
    // Reset action-related states
    setNewActionRootCauseId(null);
    setNewActionType(null);
    setNewActionData({
      title: "",
      status: ACTION_STATUS.ON_HOLD,
      owner: "",
      dueDate: "",
    });
  };

  return (
    <div>
      <GridContainer spacing={0} style={{ marginTop: "-45px" }}>
        {/* =========== Left column: Summary and matrix =========== */}
        <GridItem xs={12} sm={12} md={4}>
          <GridContainer direction="column">
            {/* Summary */}
            <GridItem xs={12} sm={12} md={12}>
              <Card className={classes.summaryCard}>
                <CardHeader color="client" icon>
                  <CardIcon color="client">
                    <Assessment />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {t("riskmanagement.summaryTitle")}
                  </h4>
                </CardHeader>
                <CardBody style={{ padding: "16px" }}>
                  {loading ? (
                    <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                      height: "100px",
                    }}>
                    <ThreeDots
                      color={clientColor || "#000000"}
                      height={100}
                      width={100}
                    />
                    </div>
                  ) : (
                    <div>
                                                                  {/* Total de Riscos - Centralizado no topo */}
                      <div style={{
                        textAlign: "center",
                        marginBottom: "12px",
                        padding: "6px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: `2px solid ${clientColor}20`,
                      }}>
                        <Typography 
                          variant="h6" 
                          style={{ 
                            fontSize: "0.6rem", 
                            fontWeight: "600", 
                            color: "#666",
                            textTransform: "uppercase",
                            marginBottom: "1px"
                          }}
                        >
                          {t("riskmanagement.totalRisksLabel")}
                      </Typography>
                        <Typography 
                          variant="h3" 
                          style={{ 
                            fontSize: "1.2rem", 
                            fontWeight: "700", 
                            color: clientColor,
                            margin: 0
                          }}
                        >
                          {totalCount}
                        </Typography>
                      </div>

                      {/* Risk Levels - Layout horizontal simples */}
                      <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        width: "100%",
                      }}>
                        {/* High Risk Level */}
                        <div 
                          onClick={() => handleFilterChange("risk_level", "High")}
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "12px 8px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            border: "2px solid #e9ecef",
                            borderTop: `6px solid ${getRiskLevelIndicatorColor("High")}`,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            minHeight: "80px",
                            justifyContent: "space-between",
                            boxShadow: "none",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                          }}
                        >
                          {/* Número + Label + Porcentagem - todos na mesma linha */}
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "8px",
                            marginTop: "4px",
                          }}>
                            <Typography 
                              style={{ 
                                fontSize: "1.2rem", 
                                fontWeight: "700", 
                                color: getRiskLevelIndicatorColor("High"),
                                margin: 0
                              }}
                            >
                              {risks.filter(r => r.risk_level === "High").length}
                            </Typography>
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "1px"
                            }}>
                              <Typography 
                                style={{ 
                                  fontSize: "0.5rem", 
                                  fontWeight: "800", 
                                  color: getRiskLevelIndicatorColor("High"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.level")}
                              </Typography>
                              <Typography 
                                style={{ 
                                  fontSize: "0.6rem", 
                                  fontWeight: "700", 
                                  color: getRiskLevelIndicatorColor("High"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.high")}
                              </Typography>
                            </div>
                            <Typography 
                              style={{ 
                                fontSize: "0.55rem", 
                                color: "#999",
                                margin: 0
                              }}
                            >
                              ({totalCount > 0 ? Math.round((risks.filter(r => r.risk_level === "High").length / totalCount) * 100) : 0}%)
                            </Typography>
                          </div>
                          
                          {/* Status Circle - Maior */}
                          <div 
                            style={{
                              ...getStatusCircleStyle(getRiskLevelGeneralStatus("High", risks)),
                              width: "30px",
                              height: "30px",
                              marginTop: "-10px",
                            }}
                          />
                          
                          {/* Indicativo de Status */}
                          <Typography 
                            style={{ 
                              fontSize: "0.45rem", 
                              fontWeight: "600", 
                              color: "#666",
                              textTransform: "uppercase",
                              marginTop: "2px",
                              textAlign: "center"
                            }}
                          >
                            {t("riskmanagement.status")}
                          </Typography>
                        </div>

                        {/* Medium Risk Level */}
                        <div 
                          onClick={() => handleFilterChange("risk_level", "Medium")}
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "12px 8px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            border: "2px solid #e9ecef",
                            borderTop: `6px solid ${getRiskLevelIndicatorColor("Medium")}`,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            minHeight: "80px",
                            justifyContent: "space-between",
                            boxShadow: "none",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                          }}
                        >
                          {/* Número + Label + Porcentagem - todos na mesma linha */}
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "8px",
                            marginTop: "4px",
                          }}>
                            <Typography 
                              style={{ 
                                fontSize: "1.2rem", 
                                fontWeight: "700", 
                                color: getRiskLevelIndicatorColor("Medium"),
                                margin: 0
                              }}
                            >
                              {risks.filter(r => r.risk_level === "Medium").length}
                            </Typography>
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "1px"
                            }}>
                              <Typography 
                                style={{ 
                                  fontSize: "0.5rem", 
                                  fontWeight: "800", 
                                  color: getRiskLevelIndicatorColor("Medium"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.level")}
                              </Typography>
                              <Typography 
                                style={{ 
                                  fontSize: "0.6rem", 
                                  fontWeight: "700", 
                                  color: getRiskLevelIndicatorColor("Medium"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.medium")}
                              </Typography>
                            </div>
                            <Typography 
                              style={{ 
                                fontSize: "0.55rem", 
                                color: "#999",
                                margin: 0
                              }}
                            >
                              ({totalCount > 0 ? Math.round((risks.filter(r => r.risk_level === "Medium").length / totalCount) * 100) : 0}%)
                            </Typography>
                          </div>
                          
                          {/* Status Circle - Maior */}
                          <div 
                            style={{
                              ...getStatusCircleStyle(getRiskLevelGeneralStatus("Medium", risks)),
                              width: "30px",
                              height: "30px",
                              marginTop: "-10px",
                            }}
                          />
                          
                          {/* Indicativo de Status */}
                          <Typography 
                            style={{ 
                              fontSize: "0.45rem", 
                              fontWeight: "600", 
                              color: "#666",
                              textTransform: "uppercase",
                              marginTop: "2px",
                              textAlign: "center"
                            }}
                          >
                            {t("riskmanagement.status")}
                          </Typography>
                        </div>

                        {/* Low Risk Level */}
                        <div 
                          onClick={() => handleFilterChange("risk_level", "Low")}
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "12px 8px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            border: "2px solid #e9ecef",
                            borderTop: `6px solid ${getRiskLevelIndicatorColor("Low")}`,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            minHeight: "80px",
                            justifyContent: "space-between",
                            boxShadow: "none",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                          }}
                        >
                          {/* Número + Label + Porcentagem - todos na mesma linha */}
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginBottom: "8px",
                            marginTop: "4px",
                          }}>
                            <Typography 
                              style={{ 
                                fontSize: "1.2rem", 
                                fontWeight: "700", 
                                color: getRiskLevelIndicatorColor("Low"),
                                margin: 0
                              }}
                            >
                              {risks.filter(r => r.risk_level === "Low").length}
                            </Typography>
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "1px"
                            }}>
                              <Typography 
                                style={{ 
                                  fontSize: "0.5rem", 
                                  fontWeight: "800", 
                                  color: getRiskLevelIndicatorColor("Low"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.level")}
                              </Typography>
                              <Typography 
                                style={{ 
                                  fontSize: "0.6rem", 
                                  fontWeight: "700", 
                                  color: getRiskLevelIndicatorColor("Low"),
                                  textTransform: "uppercase",
                                  margin: 0,
                                  lineHeight: 1
                                }}
                              >
                                {t("riskmanagement.risk_levels.low")}
                              </Typography>
                            </div>
                            <Typography 
                              style={{ 
                                fontSize: "0.55rem", 
                                color: "#999",
                                margin: 0
                              }}
                            >
                              ({totalCount > 0 ? Math.round((risks.filter(r => r.risk_level === "Low").length / totalCount) * 100) : 0}%)
                            </Typography>
                          </div>
                          
                          {/* Status Circle - Maior */}
                          <div 
                            style={{
                              ...getStatusCircleStyle(getRiskLevelGeneralStatus("Low", risks)),
                              width: "30px",
                              height: "30px",
                              marginTop: "-10px",
                            }}
                          />
                          
                          {/* Indicativo de Status */}
                          <Typography 
                            style={{ 
                              fontSize: "0.45rem", 
                              fontWeight: "600", 
                              color: "#666",
                              textTransform: "uppercase",
                              marginTop: "2px",
                              textAlign: "center"
                            }}
                          >
                            {t("riskmanagement.status")}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>

            {/* 3x3 matrix */}
            <GridItem xs={12} sm={12} md={12}>
              <Card className={classes.matrixCard}>
                <CardHeader color="client" icon>
                  <CardIcon color="client">
                    <GridOn />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {t("riskmanagement.matrixTitle")}
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      padding: "4px 12px",
                      flexWrap: "wrap",
                      fontSize: "12px",
                      color: "#aaa",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {t("riskmanagement.probability")}{" "}
                      <ArrowUpward style={{ fontSize: "14px" }} />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {t("riskmanagement.impact")}{" "}
                      <ArrowForward style={{ fontSize: "14px" }} />
                    </div>
                  </div>
                </CardHeader>
                <CardBody
                  style={{
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "0",
                  }}
                >
                  {loading ? (
                    <ThreeDots
                      color={clientColor || "#000000"}
                      height={100}
                      width={100}
                    />
                  ) : (
                    <div className={classes.matrixGrid}>
                      {matrixCells.map((cell, idx) => {
                        const count = getCellCount(cell.prob, cell.imp);
                        const cellLevel = computeRiskLevel(cell.prob, cell.imp);
                        return (
                          <div
                            key={idx}
                            className={classes.matrixCell}
                            style={getRiskLevelStyle(cellLevel)}
                            onClick={() =>
                              handleMatrixCellClick(cell.prob, cell.imp)
                            }
                          >
                            <div
                              style={{
                                marginBottom: "4px",
                                fontWeight: "bold",
                                fontSize: "1.1rem",
                              }}
                            >
                              {count}
                            </div>
                            <div>
                              {cell.prob} / {cell.imp}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>

        {/* =========== Right column: Table ========== */}
        <GridItem xs={12} sm={12} md={8}>
          <Card className={classes.riskTableCard}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Warning />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("riskmanagement.tableTitle")}
              </h4>
              <div className={classes.filterSection}>
                {/* Clean Filters button */}
                <div className={classes.clearFiltersWrapper}>
                  <Tooltip title={t("riskmanagement.clearAllFilters")}>
                    <FontAwesomeIcon
                      icon={faFilterCircleXmark}
                      style={{
                        marginRight: "16px",
                        fontSize: "20px",
                        color: "#666",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFilters({
                          status: "",
                          risk_level: "",
                          probability: "",
                          impact: "",
                        })
                      }
                    />
                  </Tooltip>
                </div>

                {/* Filters */}
                

                {/* Filtro por Status */}
                <GridItem xs={6} md={2}>
                  <FormControl
                    fullWidth
                    style={{ paddingTop: "5.2px" }}
                    size="medium"
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    <Select
                      displayEmpty
                      value={filters.status}
                      onChange={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                    >
                      <MenuItem value="">
                        {t("riskmanagement.filters.allStatuses")}
                      </MenuItem>
                      <MenuItem
                        value="Green"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Green
                      </MenuItem>
                        <MenuItem
                        value="Yellow"
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                        >
                        Yellow
                        </MenuItem>
                      <MenuItem
                        value="Red"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Red
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                <GridItem xs={6} md={2}>
                  <FormControl
                    fullWidth
                    style={{ paddingTop: "5.2px" }}
                    size="medium"
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    <Select
                      displayEmpty
                      value={filters.risk_level}
                      onChange={(e) =>
                        handleFilterChange("risk_level", e.target.value)
                      }
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                    >
                      <MenuItem value="">
                        {t("riskmanagement.filters.allLevels")}
                      </MenuItem>
                      <MenuItem
                        value="High"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        High
                      </MenuItem>
                      <MenuItem
                        value="Medium"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Medium
                      </MenuItem>
                      <MenuItem
                        value="Low"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Low
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                <GridItem xs={6} md={2}>
                  <FormControl
                    fullWidth
                    style={{ paddingTop: "5.2px" }}
                    size="medium"
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    <Select
                      displayEmpty
                      value={filters.probability}
                      onChange={(e) =>
                        handleFilterChange("probability", e.target.value)
                      }
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                    >
                      <MenuItem
                        value=""
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {t("riskmanagement.filters.allProbabilities")}
                      </MenuItem>
                      <MenuItem
                        value="Low"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Low
                      </MenuItem>
                      <MenuItem
                        value="Medium"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Medium
                      </MenuItem>
                      <MenuItem
                        value="High"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        High
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                <GridItem xs={6} md={2}>
                  <FormControl
                    fullWidth
                    style={{ paddingTop: "5.2px" }}
                    size="medium"
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    <Select
                      displayEmpty
                      value={filters.impact}
                      onChange={(e) =>
                        handleFilterChange("impact", e.target.value)
                      }
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                    >
                      <MenuItem value="">
                        {t("riskmanagement.filters.allImpacts")}
                      </MenuItem>
                      <MenuItem
                        value="Low"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Low
                      </MenuItem>
                      <MenuItem
                        value="Medium"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        Medium
                      </MenuItem>
                      <MenuItem
                        value="High"
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        High
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                {/* Button to add new risk */}
                <div
                  style={{
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title={t("riskmanagement.addNewRisk")}>
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleOpenNewRiskDrawer}
                    >
                      <AddCircle className={classes.cardButtonIcon} />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </CardHeader>

            <CardBody
              style={{
                padding: 0,
                overflow: "hidden",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: loading ? "center" : "flex-start",
                alignItems: loading ? "center" : "stretch",
                minHeight: "0", // Permite que o flex funcione corretamente
              }}
            >
              {loading ? (
                <ThreeDots
                  color={clientColor || "#000000"}
                  height={150}
                  width={150}
                />
              ) : (
                <>
                  <Table style={{ tableLayout: "fixed" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tableHeadCell}
                          onClick={() => handleSort("status")}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span>{t("riskmanagement.tableColumns.status")}</span>
                            <Tippy
                              content={
                                <span>
                                  <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                                    {t("riskmanagement.statusRules.title")}
                                  </div>
                                  <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                                    <div
                                      style={{
                                        background: "#C8E6C9",
                                        border: "2px solid #81C784",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        display: "inline-block"
                                      }}
                                    />
                                    <span style={{ fontWeight: "bold" }}>{t("riskmanagement.statusRules.green")}</span>
                                  </div>
                                  <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                                    <div
                                      style={{
                                        background: "#FFF9C4",
                                        border: "2px solid #FFB74D",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        display: "inline-block"
                                      }}
                                    />
                                    <span style={{ fontWeight: "bold" }}>{t("riskmanagement.statusRules.yellow")}</span>
                                  </div>
                                  <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                                    <div
                                      style={{
                                        background: "#FFEBEE",
                                        border: "2px solid #E57373",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        display: "inline-block"
                                      }}
                                    />
                                    <span style={{ fontWeight: "bold" }}>{t("riskmanagement.statusRules.red")}</span>
                                  </div>
                                </span>
                              }
                              theme="light"
                              arrow={true}
                              placement="top"
                            >
                              <Info
                                style={{
                                  fontSize: "16px",
                                  color: "#666",
                                  cursor: "pointer",
                                }}
                              />
                            </Tippy>
                            <FontAwesomeIcon
                              icon={
                                sortConfig.key === "status"
                                  ? sortConfig.direction === "ascending"
                                    ? faSortUp
                                    : faSortDown
                                  : faSort
                              }
                              className={
                                sortConfig.key === "status"
                                  ? `${classes.sortIcon} ${classes.activeSortIcon}`
                                  : classes.sortIcon
                              }
                            />
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tableHeadCell}
                          onClick={() => handleSort("risk_level")}
                        >
                          <div>
                            {t("riskmanagement.tableColumns.riskLevel")}
                            <FontAwesomeIcon
                              icon={
                                sortConfig.key === "risk_level"
                                  ? sortConfig.direction === "ascending"
                                    ? faSortUp
                                    : faSortDown
                                  : faSort
                              }
                              className={
                                sortConfig.key === "risk_level"
                                  ? `${classes.sortIcon} ${classes.activeSortIcon}`
                                  : classes.sortIcon
                              }
                            />
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tableHeadCell}
                          onClick={() => handleSort("title")}
                        >
                          <div>
                            {t("riskmanagement.tableColumns.risk")}
                            <FontAwesomeIcon
                              icon={
                                sortConfig.key === "title"
                                  ? sortConfig.direction === "ascending"
                                    ? faSortUp
                                    : faSortDown
                                  : faSort
                              }
                              className={
                                sortConfig.key === "title"
                                  ? `${classes.sortIcon} ${classes.activeSortIcon}`
                                  : classes.sortIcon
                              }
                            />
                          </div>
                        </TableCell>

                        <TableCell
                          className={classes.tableHeadCell}
                          onClick={() => handleSort("owner")}
                        >
                          <div>
                            {t("riskmanagement.tableColumns.owner")}
                            <FontAwesomeIcon
                              icon={
                                sortConfig.key === "owner"
                                  ? sortConfig.direction === "ascending"
                                    ? faSortUp
                                    : faSortDown
                                  : faSort
                              }
                              className={
                                sortConfig.key === "owner"
                                  ? `${classes.sortIcon} ${classes.activeSortIcon}`
                                  : classes.sortIcon
                              }
                            />
                          </div>
                        </TableCell>

    <TableCell
      className={classes.tableHeadCell}
      align="center"
    >
                          {getAltLabel("riskmanagement.tableColumns.linkedInitiatives", userDetails, t)}
                        </TableCell>
                        <TableCell
                          className={classes.tableHeadCell}
                          align="center"
                          style={{ cursor: "default" }}
                        >
                          <span>
                            {t("riskmanagement.tableColumns.actions")}
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <PerfectScrollbar
                    style={{ maxHeight: "calc(100vh - 300px)", width: "100%" }}
                  >
                    {" "}
                    {/* Ajuste maxHeight se o cabeçalho tiver altura fixa */}
                    <Table style={{ tableLayout: "fixed", width: "100%" }}>
                      <TableBody>
                        {finalList.map((risk) => {
                          return (
                            <TableRow key={risk.id}>
                              <TableCell>
                                <div
                                  style={getStatusCircleStyle(risk.status)}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1.3)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <div
                                  style={getRiskLevelCircleStyle(risk.risk_level)}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1.3)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                            style={{
                                  cursor: "pointer",
                                  color: "#2c3e50",
                                }}
                                onClick={() => openRiskDrawer(risk)}
                              >
                                {risk.title}
                              </TableCell>
                              <TableCell>{risk.owner}</TableCell>
                              <TableCell align="center">
                                {risk.linkedInitiatives && risk.linkedInitiatives.length > 0 ? (
                                  <div style={{ 
                                    maxHeight: "80px", 
                                    width: "100%",
                                    position: "relative"
                                  }}>
                                    <PerfectScrollbar
                                            style={{
                                        maxHeight: "80px",
                                        padding: "4px 8px",
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "6px",
                                        border: "1px solid #e9ecef"
                                      }}
                                    >
                                      <div style={{ fontSize: "0.8rem" }}>
                                        {risk.linkedInitiatives.map((initiative, idx) => (
                                          <div 
                                            key={idx} 
                                            style={{ 
                                              marginBottom: "6px",
                                              padding: "4px 6px",
                                              backgroundColor: "white",
                                              borderRadius: "4px",
                                              border: "1px solid #dee2e6",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                              wordBreak: "break-word",
                                              lineHeight: "1.3"
                                            }}
                                          >
                                            {initiative.name || initiative.title}
                                          </div>
                                        ))}
                                      </div>
                                    </PerfectScrollbar>
                                  </div>
                                ) : (
                                  <span style={{ 
                                    color: "#999", 
                                    fontStyle: "italic",
                                    fontSize: "0.8rem"
                                  }}>
                                    {t("riskmanagement.fields.none")}
                                  </span>
                                )}
                              </TableCell>
                              <TableCell align="center">
                                <div className={classes.actionIconsCustom}>
                                  <Tooltip
                                    title={t("riskmanagement.tooltip.editRisk")}
                                    arrow
                                  >
                                    <EditIcon
                                      className={classes.iconButtonCustom}
                                      onClick={() => openRiskDrawer(risk)}
                                      fontSize="small"
                                      style={{ marginRight: "8px" }}
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={t(
                                      "riskmanagement.tooltip.deleteRisk"
                                    )}
                                    arrow
                                  >
                                    <DeleteIcon
                                      className={classes.iconButtonCustom}
                                      onClick={() =>
                                        handleOpenDeleteDialog(risk)
                                      }
                                      fontSize="small"
                                    />
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </PerfectScrollbar>
                </>
              )}
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          open={deleteDialogOpen}
          onClose={handleCloseDeleteDialog}
          aria-labelledby="delete-risk-dialog-title"
          aria-describedby="delete-risk-dialog-description"
        >
          <DialogTitle id="delete-risk-dialog-title">
            {t("riskmanagement.confirmDeleteTitle")}
          </DialogTitle>
          <DialogContent>
            <Typography>
              {t("riskmanagement.confirmDeleteMessage", {
                riskName: riskToDelete?.title || "this risk",
              })}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteDialog} color="primary">
              {t("riskmanagement.cancel")}
            </Button>
            <Button onClick={() => handleDeleteRisk()} color="secondary">
              {t("riskmanagement.delete")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={discardDialogOpen}
          onClose={() => setDiscardDialogOpen(false)}
          aria-labelledby="discard-dialog-title"
        >
          <DialogTitle id="discard-dialog-title">
            {t("riskmanagement.confirmDiscardTitle")}
          </DialogTitle>
          <DialogContent>
            <Typography>{t("riskmanagement.confirmDiscardMessage")}</Typography>
          </DialogContent>
          <DialogActions>
            {/* Discard */}
            <Button
              onClick={() => {
                // CLOSE DIALOG

                setDiscardDialogOpen(false);
                // Discard the changes and actually closes

                closeRiskDrawer();
              }}
              color="secondary"
            >
              {t("riskmanagement.discard")}
            </Button>

            {/* Save button */}
            <Button
              onClick={() => {
                // If you want to save when discarding

                if (selectedRisk) {
                  updateRisk(selectedRisk);
                } else {
                  saveNewRisk();
                }
                // CLOSE DIALOG

                setDiscardDialogOpen(false);
              }}
              color="primary"
            >
              {t("riskmanagement.save")}
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>

      {/* ============ Floating AI Insights Button ========== */}
      <div
        style={{
          position: 'fixed',
          right: 16,
          bottom: 40,
          zIndex: 1300,
        }}
      >
        <Tooltip title={t("risk_insights.button_tooltip")} placement="left">
          <IconButton
            style={{
              background: userDetails?.implementation_color || '#1976d2',
              color: '#fff',
              border: '1px solid #ccc',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              width: 40,
              height: 40,
            }}
            onClick={handleGetAIInsights}
            disabled={loading}
          >
            <EmojiObjects style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </div>

      {/* ============ AI Insights Modal ========== */}
      <AIInsightsModal
        open={insightsModalOpen}
        onClose={handleCloseInsights}
        title="risk_insights.modal_title"
        disclaimer="risk_insights.ai_disclaimer"
        content={insightsContent}
        isLoading={insightsLoading}
        error={insightsError}
        onCopy={handleCopyInsightsToClipboard}
        isCopying={isCopyingInsights}
        userDetails={userDetails}
        copySuccessKey="risk_insights.copied_success"
        copyTooltipKey="risk_insights.copy_to_clipboard"
        noContentKey="risk_insights.no_content"
        closeLabelKey="general.close"
        loadingComponent={
          <RiskInsightsLoading
            isLoading={insightsLoading}
            interval={2500}
            loadingComponent={
              <ThreeDots
                color={userDetails?.implementation_color || '#1976d2'}
                height={80}
                width={80}
                ariaLabel="loading"
              />
            }
          />
        }
        markdownComponents={{
          h1: ({ children }) => (
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '12px', marginTop: '16px' }}>
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop: '14px' }}>
              {children}
            </Typography>
          ),
          h3: ({ children }) => (
            <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: '12px' }}>
              {children}
            </Typography>
          ),
          h4: ({ children }) => (
            <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '6px', marginTop: '10px' }}>
              {children}
            </Typography>
          ),
          p: ({ children }) => (
            <Typography variant="body1" style={{ marginBottom: '8px' }}>
              {children}
            </Typography>
          ),
          strong: ({ children }) => (
            <span style={{ fontWeight: 'bold' }}>{children}</span>
          ),
          li: ({ children }) => (
            <li style={{ marginBottom: '4px' }}>{children}</li>
          ),
          ul: ({ children }) => (
            <ul style={{ marginBottom: '12px', paddingLeft: '20px' }}>{children}</ul>
          ),
          ol: ({ children }) => (
            <ol style={{ marginBottom: '12px', paddingLeft: '20px' }}>{children}</ol>
          ),
        }}
      />

      {/* ============ Detail Drawer /Risk Edition ========== */}
      <Drawer
        anchor="right"
        open={isDrawerOpen || isNewRiskDrawerOpen}
        onClose={() => {
          const isEditing = !!selectedRisk;
          if (isEditing && hasUnsavedChanges) {
            // Only opens Dialog if it is in editing and there are changes

            setDiscardDialogOpen(true);
          } else {
            // Otherwise, it closes normally

            closeRiskDrawer();
          }
        }}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
            width: "800px",
          },
        }}
      >
        <div style={{ position: "relative", padding: "16px" }}>
          {/* Save button on top */}
          <div
            style={{
              position: "absolute",
              right: "15px",
              top: "10px",
              zIndex: 1000,
            }}
          >
            <Tooltip title={t("riskmanagement.saveChanges")}>
              <Button
                justIcon
                color="client"
                className={classes.cardButton}
                onClick={() => {
                  // Creation mode ➡️ POST action:"create_risk"
                  if (isNewRiskDrawerOpen) {
                    saveNewRisk();
                    return;
                  }

                  // Edit mode ➡️ POST action:"update_risk"
                  if (selectedRisk) {
                    updateRisk(selectedRisk);
                  }
                }}
              >
                <SaveIcon className={classes.cardButtonIcon} />
              </Button>
            </Tooltip>
          </div>

          {/****************************************************************
     UNIFICATION:
     1) We check whether it is edition (selectedisk) or new (newriskform)
     2) "Riskdata" will be the current "object": (selectedisk || newriskform)
     3) Setriskdatafield function () => updates edition or new
    ****************************************************************/}

          {(() => {
            const isEditing = !!selectedRisk; // If True => Edition, if not => New

            const riskData = isEditing ? selectedRisk : newRiskForm;

            // Helper to change any field

            function setRiskDataField(field, value) {
              if (isEditing) {
                // Edition

                setSelectedRisk((prev) => ({ ...prev, [field]: value }));
                setHasUnsavedChanges(true);
              } else {
                // New

                setNewRiskForm((prev) => ({ ...prev, [field]: value }));
                setHasUnsavedChanges(true);
              }
            }

            // Helpers for mit/cont

            const hasMitigation = riskData.hasMitigationPlan;
            const hasContingency = riskData.hasContingencyPlan;

            return (
              <>
                <Typography variant="h6" gutterBottom>
                  {
                    isEditing
                      ? t("riskmanagement.riskDetails") // Edition
                      : t("riskmanagement.addNewRisk") // Creation
                  }
                </Typography>

                {/* Here we unify the 3 tabs of always */}
                <Tabs
                  value={detailTab}
                  onChange={handleTabChange}
                  classes={{
                    root: classes.tabsRoot,
                    indicator: classes.indicator,
                  }}
                  variant="fullWidth"
                >
                  <Tab
                    label={t("riskmanagement.tabs.riskDetails")}
                    classes={{ root: classes.tabRoot }}
                  />

                  {hasMitigation && (
                    <Tab
                      label={t("riskmanagement.tabs.mitigationActions")}
                      classes={{ root: classes.tabRoot }}
                    />
                  )}
                  {hasContingency && (
                    <Tab
                      label={t("riskmanagement.tabs.contingencyActions")}
                      classes={{ root: classes.tabRoot }}
                    />
                  )}
                </Tabs>

                {/* Tab 0 => details */}
                {detailTab === 0 && (
                  <Box p={2}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={2}
                      style={{
                        borderBottom: "1px dotted #ccc",
                        marginBottom: "24px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 600 }}
                      >
                        {/* Risk Details Title */}
                        {t("riskmanagement.risk_details_title")}
                      </Typography>

                      {/* Info icon for Risk Details */}
                      <Tooltip
                        title={t("riskmanagement.info_tooltips.risk_details")}
                        arrow
                      >
                        <Info
                          style={{
                            fontSize: "18px", // icon size

                            marginLeft: "8px", // space between text and icon

                            color: "#666", // same color as the text

                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </Box>
                    <form noValidate autoComplete="off">
                      <TextField
                        label={t("riskmanagement.fields.title")}
                        fullWidth
                        margin="normal"
                        value={riskData.title || ""}
                        onChange={(e) =>
                          setRiskDataField("title", e.target.value)
                        }
                        classes={{ root: classes.textFieldRoot }}
                      />

                      <GridContainer spacing={2}>
                        <GridItem xs={12} sm={6}>
                          <TextField
                            select
                            fullWidth
                            label={t("riskmanagement.fields.probability")}
                            margin="normal"
                            value={riskData.probability || "Medium"}
                            onChange={(e) => {
                              setRiskDataField("probability", e.target.value);
                              const newLvl = computeRiskLevel(
                                e.target.value,
                                riskData.impact
                              );
                              setRiskDataField("risk_level", newLvl);
                            }}
                            classes={{ root: classes.textFieldRoot }}
                          >
                            <MenuItem value="Low">Low</MenuItem>
                            <MenuItem value="Medium">Medium</MenuItem>
                            <MenuItem value="High">High</MenuItem>
                          </TextField>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                          <TextField
                            select
                            fullWidth
                            label={t("riskmanagement.fields.impact")}
                            margin="normal"
                            value={riskData.impact || "Medium"}
                            onChange={(e) => {
                              setRiskDataField("impact", e.target.value);
                              const newLvl = computeRiskLevel(
                                riskData.probability,
                                e.target.value
                              );
                              setRiskDataField("risk_level", newLvl);
                            }}
                            classes={{ root: classes.textFieldRoot }}
                          >
                            <MenuItem value="Low">Low</MenuItem>
                            <MenuItem value="Medium">Medium</MenuItem>
                            <MenuItem value="High">High</MenuItem>
                          </TextField>
                        </GridItem>
                      </GridContainer>

                      <TextField
                        select
                        label={t("riskmanagement.fields.owner")}
                        fullWidth
                        margin="normal"
                        value={riskData.owner || ""}
                        onChange={(e) =>
                          setRiskDataField("owner", e.target.value)
                        }
                        classes={{ root: classes.textFieldRoot }}
                      >
                        <MenuItem value="">(None)</MenuItem>
                        {userOptions.map((user) => (
                          <MenuItem key={user.id} value={user.name}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </TextField>



                      {/* Campo para seleção múltipla de iniciativas */}
                      <div style={{ marginTop: "16px" }}>
                        <label style={{ 
                          display: "block", 
                          marginBottom: "8px", 
                          color: "#666",
                          fontSize: "0.875rem"
                        }}>
                          {getAltLabel("riskmanagement.fields.linkedInitiatives", userDetails, t)}
                        </label>
                        <ReactSelect
                          isMulti
                          options={
                            !initiativeOptions || initiativeOptions.length === 0
                              ? []
                              : initiativeOptions.map(init => ({
                                  value: init.id,
                                  label: init.name || init.title
                                }))
                          }
                          value={
                            riskData.linkedInitiatives && Array.isArray(riskData.linkedInitiatives)
                              ? riskData.linkedInitiatives.map(init => ({
                                  value: init.id,
                                  label: init.name || init.title
                                }))
                              : []
                          }
                          onChange={(selected) => {
                            const selectedInitiatives = (selected || []).map(option => {
                              const initiative = initiativeOptions.find(init => init.id === option.value);
                              return initiative || { id: option.value, name: option.label };
                            });
                            setRiskDataField("linkedInitiatives", selectedInitiatives);
                          }}
                          placeholder={
                            loading ? "Carregando iniciativas..." : 
                            initiativeOptions.length === 0 ? "Nenhuma iniciativa disponível" :
                            getAltLabel("riskmanagement.fields.selectInitiatives", userDetails, t)
                          }
                          isDisabled={loading || initiativeOptions.length === 0}
                          closeMenuOnSelect={false}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: state.isFocused ? clientColor : "#ccc",
                              "&:hover": { borderColor: clientColor },
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isSelected ? clientColor : state.isFocused ? "#f0f0f0" : "white",
                              color: state.isSelected ? "white" : "black",
                            }),
                          }}
                        />
                      </div>

                      <TextField
                        label={t("riskmanagement.fields.description")}
                        fullWidth
                        margin="normal"
                        multiline
                        rows={3}
                        value={riskData.description || ""}
                        onChange={(e) =>
                          setRiskDataField("description", e.target.value)
                        }
                        classes={{ root: classes.textFieldRoot }}
                      />

                      <TextField
                        label={t("riskmanagement.fields.dueDate")}
                        type="date"
                        fullWidth
                        margin="normal"
                        value={riskData.dueDate || ""}
                        onChange={(e) =>
                          setRiskDataField("dueDate", e.target.value)
                        }
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{ classes: { input: classes.inputText } }}
                        InputLabelProps={{
                          classes: { root: classes.labelText },
                          shrink: true,
                        }}
                      />

                      {/* Checkboxes to enable Mitigation/Contingency Plans */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!riskData.hasMitigationPlan}
                            onChange={(e) =>
                              setRiskDataField(
                                "hasMitigationPlan",
                                e.target.checked
                              )
                            }
                            style={{ color: clientColor }}
                          />
                        }
                        label={t("riskmanagement.fields.hasMitigationPlan")}
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!riskData.hasContingencyPlan}
                            onChange={(e) =>
                              setRiskDataField(
                                "hasContingencyPlan",
                                e.target.checked
                              )
                            }
                            style={{ color: clientColor }}
                          />
                        }
                        label={t("riskmanagement.fields.hasContingencyPlan")}
                      />
                      
                      {/* Novo campo para risco materializado */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!riskData.isMaterialized}
                            onChange={(e) =>
                              setRiskDataField(
                                "isMaterialized",
                                e.target.checked
                              )
                            }
                            style={{ color: clientColor }}
                          />
                        }
                        label={t("riskmanagement.fields.isMaterialized")}
                      />
                    </form>
                    {/* =========================================
       SECTION: Root Causes
       ========================================= */}
                    <Box mt={4}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={1}
                        style={{
                          borderBottom: "1px dotted #ccc",
                          marginBottom: "24px",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: 600 }}
                        >
                          {t("riskmanagement.root_cause_title")}
                        </Typography>

                        {/* Info icon for Root Causes */}
                        <Tooltip
                          title={t("riskmanagement.info_tooltips.root_causes")}
                          arrow
                        >
                          <Info
                            style={{
                              fontSize: "18px",
                              marginLeft: "8px",
                              color: "#666",
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </Box>

                      <Button
                        color="client"
                        disabled={
                          riskData.rootCauses && riskData.rootCauses.length >= 3
                        }
                        onClick={() => {
                          if (!riskData.rootCauses) {
                            setRiskDataField("rootCauses", []);
                          }
                          if (
                            riskData.rootCauses &&
                            riskData.rootCauses.length < 3
                          ) {
                            const newRC = {
                              id:
                                "RC" + Date.now() + "_" + Math.random().toString(36).substr(2, 5),
                              cause: "",
                              actions: [],
                            };
                            const updated = [...riskData.rootCauses, newRC];
                            setRiskDataField("rootCauses", updated);
                          }
                        }}
                        style={{ marginBottom: "8px" }}
                      >
                        {t("riskmanagement.buttons.addRootCause")}
                      </Button>

                      {riskData.rootCauses &&
                        riskData.rootCauses.map((rc) => (
                          <div
                            key={rc.id}
                            className={classes.rootCauseContainer}
                          >
                            <div className={classes.rootCauseHeader}>
                              <TextField
                                label={t("riskmanagement.fields.rootCause")}
                                fullWidth
                                value={rc.cause}
                                onChange={(e) => {
                                  const updatedRCs = riskData.rootCauses.map(
                                    (item) =>
                                      item.id === rc.id
                                        ? { ...item, cause: e.target.value }
                                        : item
                                  );
                                  setRiskDataField("rootCauses", updatedRCs);
                                }}
                                classes={{ root: classes.textFieldRoot }}
                              />
                              <Tooltip
                                title={t(
                                  "riskmanagement.tooltip.removeRootCause"
                                )}
                                arrow
                              >
                                <IconButton
                                  onClick={() => {
                                    const filtered = riskData.rootCauses.filter(
                                      (item) => item.id !== rc.id
                                    );
                                    setRiskDataField("rootCauses", filtered);
                                  }}
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </div>
                        ))}
                    </Box>
                  </Box>
                )}

                {hasMitigation && detailTab === 1 && (
                  <Box p={2}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={2}
                      style={{
                        borderBottom: "1px dotted #ccc",
                        marginBottom: "24px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 600 }}
                      >
                        {t("riskmanagement.fields.mitigationActionsHeader")}
                      </Typography>

                      {/* Info icon for Mitigation Actions */}
                      <Tooltip
                        title={t(
                          "riskmanagement.info_tooltips.mitigation_actions"
                        )}
                        arrow
                      >
                        <Info
                          style={{
                            fontSize: "18px",
                            marginLeft: "8px",
                            color: "#666",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </Box>
                    {riskData.rootCauses &&
                      riskData.rootCauses.map((rc) => (
                        <div key={rc.id} className={classes.rootCauseContainer}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 600 }}
                          >
                            {t("riskmanagement.fields.rootCauseLabel")}{" "}
                            {rc.cause ||
                              `${t("riskmanagement.fields.noCauseDescription")}`}
                          </Typography>
                          {rc.actions && Array.isArray(rc.actions)
                            ? rc.actions
                            .filter((act) => act.type === "mitigation")
                            .map((act) => (
                              <div
                                key={act.id}
                                className={classes.actionContainer}
                              >
                                <div className={classes.actionHeader}>
                                  <TextField
                                    label={t(
                                      "riskmanagement.fields.actionTitle"
                                    )}
                                    fullWidth
                                    value={act.title}
                                    onChange={(e) =>
                                      updateActionField(
                                        riskData,
                                        rc.id,
                                        act.id,
                                        "title",
                                        e.target.value
                                      )
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                  />
                                  <Tooltip
                                    title={t(
                                      "riskmanagement.tooltip.removeAction"
                                    )}
                                  >
                                    <IconButton
                                      onClick={() =>
                                        removeAction(riskData, rc.id, act.id)
                                      }
                                    >
                                      <ClearIcon />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                                <GridContainer spacing={1}>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      select
                                      label={t("riskmanagement.fields.status")}
                                      fullWidth
                                      value={act.status}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "status",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    >
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.done"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.done")}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.atrasada"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.atrasada")}
                                      </MenuItem>
                                    </TextField>
                                  </GridItem>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      select
                                      label={t(
                                        "riskmanagement.fields.actionOwner"
                                      )}
                                      fullWidth
                                      value={act.owner}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "owner",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    >
                                      <MenuItem
                                        value=""
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        (None)
                                      </MenuItem>
                                      {userOptions.map((user) => (
                                        <MenuItem
                                          key={user.id}
                                          value={user.name}
                                        >
                                          {user.name}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </GridItem>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      label={t(
                                        "riskmanagement.fields.actionDueDate"
                                      )}
                                      type="date"
                                      fullWidth
                                      value={act.dueDate}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "dueDate",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                        shrink: true,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                                {act.updates && act.updates.length > 0 && (
                                  <div className={classes.updateContainer}>
                                    {act.updates.map((upd, idx) => (
                                      <div
                                        key={idx}
                                        className={classes.updateEntry}
                                      >
                                        <strong>{upd.date}</strong>{" "}
                                        {t("riskmanagement.update.by")}{" "}
                                        {upd.user}: {upd.comment}
                                        {upd.oldStatus !== upd.newStatus && (
                                          <div style={{ fontStyle: "italic" }}>
                                            (Status: {upd.oldStatus} →{" "}
                                            {upd.newStatus})
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {actionOpenUpdateForm === act.id ? (
                                  <div
                                    style={{
                                      marginTop: "8px",
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "6px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    <TextField
                                      label={t("riskmanagement.fields.comment")}
                                      fullWidth
                                      multiline
                                      rows={2}
                                      value={newUpdateComment}
                                      onChange={(e) =>
                                        setNewUpdateComment(e.target.value)
                                      }
                                      style={{ marginBottom: "6px" }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    />
                                    <TextField
                                      select
                                      fullWidth
                                      label={t(
                                        "riskmanagement.fields.newStatusOptional"
                                      )}
                                      value={newUpdateStatus}
                                      onChange={(e) =>
                                        setNewUpdateStatus(e.target.value)
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      style={{ marginBottom: "6px" }}
                                    >
                                      <MenuItem
                                        value=""
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.keepCurrent"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.done"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.done")}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.atrasada"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.atrasada")}
                                      </MenuItem>
                                    </TextField>
                                    <div
                                      style={{ display: "flex", gap: "8px" }}
                                    >
                                      <Tooltip
                                        title={t(
                                          "riskmanagement.tooltip.addUpdate"
                                        )}
                                      >
                                        <Button
                                          justIcon
                                          color="client"
                                          className={classes.cardButton}
                                          onClick={() =>
                                            addUpdateToAction(
                                              riskData,
                                              rc.id,
                                              act
                                            )
                                          }
                                        >
                                          <SaveIcon
                                            className={classes.cardButtonIcon}
                                          />
                                        </Button>
                                      </Tooltip>
                                      <Tooltip
                                        title={t(
                                          "riskmanagement.tooltip.cancel"
                                        )}
                                      >
                                        <Button
                                          className={classes.cardButtonCancel}
                                          onClick={closeUpdateForm}
                                        >
                                          <Cancel
                                            className={classes.cardButtonIcon}
                                          />
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  </div>
                                ) : (
                                  <Tooltip
                                    title={t(
                                      "riskmanagement.tooltip.addUpdate"
                                    )}
                                  >
                                    <Button
                                      justIcon
                                      color="client"
                                      className={classes.cardButton}
                                      style={{ marginTop: "6px" }}
                                      onClick={() => openUpdateForm(act.id)}
                                    >
                                      <AddCircle
                                        className={classes.cardButtonIcon}
                                      />
                                    </Button>
                                  </Tooltip>
                                )}
                              </div>
                            ))
                            : null}
                          {/* ===== New Mitigation Action Creation Form ===== */}
                          {newActionRootCauseId === rc.id &&
                          newActionType === "mitigation" ? (
                            <div
                              style={{
                                marginTop: "8px",
                                border: "1px solid #ccc",
                                padding: "12px",
                                borderRadius: "6px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                style={{ fontWeight: 600, marginBottom: "8px" }}
                              >
                                {t("riskmanagement.addNewAction")}
                              </Typography>

                              <TextField
                                label={t("riskmanagement.fields.actionTitle")}
                                fullWidth
                                value={newActionData.title}
                                onChange={(e) =>
                                  setNewActionData((prev) => ({
                                    ...prev,
                                    title: e.target.value,
                                  }))
                                }
                                style={{ marginBottom: "8px" }}
                                classes={{ root: classes.textFieldRoot }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true,
                                }}
                              />

                              <GridContainer spacing={1}>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    select
                                    label={t("riskmanagement.fields.status")}
                                    fullWidth
                                    value={newActionData.status}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        status: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  >
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.onHold"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t("riskmanagement.actionStatus.onHold")}
                                    </MenuItem>
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.inProgress"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t(
                                        "riskmanagement.actionStatus.inProgress"
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.done"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t("riskmanagement.actionStatus.done")}
                                    </MenuItem>
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.atrasada"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t("riskmanagement.actionStatus.atrasada")}
                                    </MenuItem>
                                  </TextField>
                                </GridItem>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    select
                                    label={t(
                                      "riskmanagement.fields.actionOwner"
                                    )}
                                    fullWidth
                                    value={newActionData.owner}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        owner: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  >
                                    <MenuItem
                                      value=""
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      (None)
                                    </MenuItem>
                                    {userOptions.map((user) => (
                                      <MenuItem key={user.id} value={user.name}>
                                        {user.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </GridItem>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    label={t(
                                      "riskmanagement.fields.actionDueDate"
                                    )}
                                    type="date"
                                    fullWidth
                                    value={newActionData.dueDate}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        dueDate: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>

                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  marginTop: "12px",
                                }}
                              >
                                <Tooltip
                                  title={t("riskmanagement.saveChanges")}
                                >
                                  <Button
                                    justIcon
                                    color="client"
                                    className={classes.cardButton}
                                    onClick={() =>
                                      saveNewAction(riskData, rc.id)
                                    }
                                  >
                                    <SaveIcon
                                      className={classes.cardButtonIcon}
                                    />
                                  </Button>
                                </Tooltip>
                                <Tooltip
                                  title={t("riskmanagement.tooltip.cancel")}
                                >
                                  <Button
                                    className={classes.cardButtonCancel}
                                    onClick={closeNewActionForm}
                                  >
                                    <Cancel
                                      className={classes.cardButtonIcon}
                                    />
                                  </Button>
                                </Tooltip>
                              </div>
                            </div>
                          ) : (
                            <Tooltip
                              title={t(
                                "riskmanagement.buttons.addMitigationAction"
                              )}
                            >
                              <Button
                                justIcon
                                color="client"
                                className={classes.cardButton}
                                onClick={() =>
                                  openNewActionForm(rc.id, "mitigation")
                                }
                              >
                                <AddCircle className={classes.cardButtonIcon} />
                              </Button>
                            </Tooltip>
                          )}
                        </div>
                      ))}
                  </Box>
                )}

                {hasContingency && detailTab === (hasMitigation ? 2 : 1) && (
                  <Box p={2}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={2}
                      style={{
                        borderBottom: "1px dotted #ccc",
                        marginBottom: "24px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 600 }}
                      >
                        {t("riskmanagement.fields.contingencyActionsHeader")}
                      </Typography>

                      {/* Info icon for Contingency Actions */}
                      <Tooltip
                        title={t(
                          "riskmanagement.info_tooltips.contingency_actions"
                        )}
                        arrow
                      >
                        <Info
                          style={{
                            fontSize: "18px",
                            marginLeft: "8px",
                            color: "#666",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </Box>
                    {riskData.rootCauses &&
                      riskData.rootCauses.map((rc) => (
                        <div key={rc.id} className={classes.rootCauseContainer}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 600 }}
                          >
                            {t("riskmanagement.fields.rootCauseLabel")}{" "}
                            {rc.cause ||
                              `${t("riskmanagement.fields.noCauseDescription")}`}
                          </Typography>
                          {rc.actions && Array.isArray(rc.actions)
                            ? rc.actions
                            .filter((act) => act.type === "contingency")
                            .map((act) => (
                              <div
                                key={act.id}
                                className={classes.actionContainer}
                              >
                                <div className={classes.actionHeader}>
                                  <TextField
                                    label={t(
                                      "riskmanagement.fields.actionTitle"
                                    )}
                                    fullWidth
                                    value={act.title}
                                    onChange={(e) =>
                                      updateActionField(
                                        riskData,
                                        rc.id,
                                        act.id,
                                        "title",
                                        e.target.value
                                      )
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                  />
                                  <Tooltip
                                    title={t(
                                      "riskmanagement.tooltip.removeAction"
                                    )}
                                  >
                                    <IconButton
                                      onClick={() =>
                                        removeAction(riskData, rc.id, act.id)
                                      }
                                    >
                                      <ClearIcon />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                                <GridContainer spacing={1}>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      select
                                      label={t("riskmanagement.fields.status")}
                                      fullWidth
                                      value={act.status}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "status",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    >
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.done"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.done")}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.atrasada"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.atrasada")}
                                      </MenuItem>
                                    </TextField>
                                  </GridItem>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      select
                                      label={t(
                                        "riskmanagement.fields.actionOwner"
                                      )}
                                      fullWidth
                                      value={act.owner}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "owner",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    >
                                      <MenuItem
                                        value=""
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        (None)
                                      </MenuItem>
                                      {userOptions.map((user) => (
                                        <MenuItem
                                          key={user.id}
                                          value={user.name}
                                        >
                                          {user.name}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </GridItem>
                                  <GridItem xs={12} sm={4}>
                                    <TextField
                                      label={t(
                                        "riskmanagement.fields.actionDueDate"
                                      )}
                                      type="date"
                                      fullWidth
                                      value={act.dueDate}
                                      onChange={(e) =>
                                        updateActionField(
                                          riskData,
                                          rc.id,
                                          act.id,
                                          "dueDate",
                                          e.target.value
                                        )
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                        shrink: true,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                                {act.updates && act.updates.length > 0 && (
                                  <div className={classes.updateContainer}>
                                    {act.updates.map((upd, idx) => (
                                      <div
                                        key={idx}
                                        className={classes.updateEntry}
                                      >
                                        <strong>{upd.date}</strong>{" "}
                                        {t("riskmanagement.update.by")}{" "}
                                        {upd.user}: {upd.comment}
                                        {upd.oldStatus !== upd.newStatus && (
                                          <div style={{ fontStyle: "italic" }}>
                                            (Status: {upd.oldStatus} →{" "}
                                            {upd.newStatus})
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {actionOpenUpdateForm === act.id ? (
                                  <div
                                    style={{
                                      marginTop: "8px",
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "6px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    <TextField
                                      label={t("riskmanagement.fields.comment")}
                                      fullWidth
                                      multiline
                                      rows={2}
                                      value={newUpdateComment}
                                      onChange={(e) =>
                                        setNewUpdateComment(e.target.value)
                                      }
                                      style={{ marginBottom: "6px" }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                    />
                                    <TextField
                                      select
                                      fullWidth
                                      label={t(
                                        "riskmanagement.fields.newStatusOptional"
                                      )}
                                      value={newUpdateStatus}
                                      onChange={(e) =>
                                        setNewUpdateStatus(e.target.value)
                                      }
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        classes: { input: classes.inputText },
                                      }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      style={{ marginBottom: "6px" }}
                                    >
                                      <MenuItem
                                        value=""
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.keepCurrent"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.onHold"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t(
                                          "riskmanagement.actionStatus.inProgress"
                                        )}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.done"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.done")}
                                      </MenuItem>
                                      <MenuItem
                                        value={t(
                                          "riskmanagement.actionStatus.atrasada"
                                        )}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                      >
                                        {t("riskmanagement.actionStatus.atrasada")}
                                      </MenuItem>
                                    </TextField>
                                    <div
                                      style={{ display: "flex", gap: "8px" }}
                                    >
                                      <Tooltip
                                        title={t(
                                          "riskmanagement.tooltip.addUpdate"
                                        )}
                                      >
                                        <Button
                                          justIcon
                                          color="client"
                                          className={classes.cardButton}
                                          onClick={() =>
                                            addUpdateToAction(
                                              riskData,
                                              rc.id,
                                              act
                                            )
                                          }
                                        >
                                          <SaveIcon
                                            className={classes.cardButtonIcon}
                                          />
                                        </Button>
                                      </Tooltip>
                                      <Tooltip
                                        title={t(
                                          "riskmanagement.tooltip.cancel"
                                        )}
                                      >
                                        <Button
                                          className={classes.cardButtonCancel}
                                          onClick={closeUpdateForm}
                                        >
                                          <Cancel
                                            className={classes.cardButtonIcon}
                                          />
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  </div>
                                ) : (
                                  <Tooltip
                                    title={t(
                                      "riskmanagement.tooltip.addUpdate"
                                    )}
                                  >
                                    <Button
                                      justIcon
                                      color="client"
                                      className={classes.cardButton}
                                      style={{ marginTop: "6px" }}
                                      onClick={() => openUpdateForm(act.id)}
                                    >
                                      <AddCircle
                                        className={classes.cardButtonIcon}
                                      />
                                    </Button>
                                  </Tooltip>
                                )}
                              </div>
                            ))
                            : null}
                          {/* ===== New Continency Action Creation Form ===== */}
                          {newActionRootCauseId === rc.id &&
                          newActionType === "contingency" ? (
                            <div
                              style={{
                                marginTop: "8px",
                                border: "1px solid #ccc",
                                padding: "12px",
                                borderRadius: "6px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                style={{ fontWeight: 600, marginBottom: "8px" }}
                              >
                                {t("riskmanagement.addNewAction")}
                              </Typography>

                              <TextField
                                label={t("riskmanagement.fields.actionTitle")}
                                fullWidth
                                value={newActionData.title}
                                onChange={(e) =>
                                  setNewActionData((prev) => ({
                                    ...prev,
                                    title: e.target.value,
                                  }))
                                }
                                style={{ marginBottom: "8px" }}
                                classes={{ root: classes.textFieldRoot }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true,
                                }}
                              />

                              <GridContainer spacing={1}>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    select
                                    label={t("riskmanagement.fields.status")}
                                    fullWidth
                                    value={newActionData.status}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        status: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  >
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.onHold"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t("riskmanagement.actionStatus.onHold")}
                                    </MenuItem>
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.inProgress"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t(
                                        "riskmanagement.actionStatus.inProgress"
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      value={t(
                                        "riskmanagement.actionStatus.done"
                                      )}
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      {t("riskmanagement.actionStatus.done")}
                                    </MenuItem>
                                  </TextField>
                                </GridItem>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    select
                                    label={t(
                                      "riskmanagement.fields.actionOwner"
                                    )}
                                    fullWidth
                                    value={newActionData.owner}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        owner: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  >
                                    <MenuItem
                                      value=""
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                    >
                                      (None)
                                    </MenuItem>
                                    {userOptions.map((user) => (
                                      <MenuItem key={user.id} value={user.name}>
                                        {user.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </GridItem>
                                <GridItem xs={12} sm={4}>
                                  <TextField
                                    label={t(
                                      "riskmanagement.fields.actionDueDate"
                                    )}
                                    type="date"
                                    fullWidth
                                    value={newActionData.dueDate}
                                    onChange={(e) =>
                                      setNewActionData((prev) => ({
                                        ...prev,
                                        dueDate: e.target.value,
                                      }))
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                      shrink: true,
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>

                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  marginTop: "12px",
                                }}
                              >
                                <Tooltip
                                  title={t("riskmanagement.saveChanges")}
                                >
                                  <Button
                                    justIcon
                                    color="client"
                                    className={classes.cardButton}
                                    onClick={() =>
                                      saveNewAction(riskData, rc.id)
                                    }
                                  >
                                    <SaveIcon
                                      className={classes.cardButtonIcon}
                                    />
                                  </Button>
                                </Tooltip>
                                <Tooltip
                                  title={t("riskmanagement.tooltip.cancel")}
                                >
                                  <Button
                                    className={classes.cardButtonCancel}
                                    onClick={closeNewActionForm}
                                  >
                                    <Cancel
                                      className={classes.cardButtonIcon}
                                    />
                                  </Button>
                                </Tooltip>
                              </div>
                            </div>
                          ) : (
                            <Tooltip
                              title={t(
                                "riskmanagement.buttons.addContingencyAction"
                              )}
                            >
                              <Button
                                justIcon
                                color="client"
                                className={classes.cardButton}
                                onClick={() =>
                                  openNewActionForm(rc.id, "contingency")
                                }
                              >
                                <AddCircle className={classes.cardButtonIcon} />
                              </Button>
                            </Tooltip>
                          )}
                        </div>
                      ))}
                  </Box>
                )}
              </>
            );
          })()}
        </div>
      </Drawer>
    </div>
  );
}
